module.exports = __webpack_public_path__ + "img/NichtGutKirschenEssen.16e57eb6.svg";